<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'Comments'}">
              <h4 class="m-dir-2">
                {{ label.router.ManageComments }}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
              <small class="fw1">
                {{label.pages.listOfComments}}
              </small>
            </h4>
          </b-col>
          <b-col sm="2" class="text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <b-tabs
              nav-class="tab-title"
              active-nav-item-class="tab-title-active"
              fill
              justified
              pills
          >
            <!-- Unapproved -->
            <b-tab active>
              <template #title>
                {{label.pages.waitingToConfirm}}
              </template>
              <DxDataGrid
                  :show-row-lines="true"
                  :show-column-lines="true"
                  :show-borders="true"
                  :row-alternation-enabled="true"
                  :rtl-enabled="true"
                  :data-source="unapprovedComments"
                  :columns="unFields"
                  :remote-operations="true"
                  :column-auto-width="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  column-resizing-mode="widget"
                  :hover-state-enabled="true"
                  :noDataText="checkData"
                  @toolbar-preparing="onToolbarPreparing($event)"
                  key-expr="id"
                  class="ps_Table"
                  :height="dataGridHeight-50"
              >
                <DxSearchPanel
                    :visible="true"
                    :width="240"
                    :placeholder="label.pages.search"
                />
                <DxColumnChooser
                    :enabled="true"
                    mode="dragAndDrop"
                />
                <DxExport
                    :enabled="true"
                />
                <template #btnGroup>
                  <div>
                    <b-row class="ms-2">
                      <b-col cols="auto" class="px-0">
                        <b-button
                            variant="ps-secondary"
                            class="py-1 pb-2"
                            size="sm"
                            v-b-tooltip.hover
                            :title="label.buttons.reload"
                            @click="reloadDataUnapproved"
                        >
                          <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                </template>
                <template #btnRGroup>
                  <b-row>
                    <b-col cols="5">
                      <date-picker
                          class="p-datePicker"
                          color="#3AAFA9"
                          input-class="p-datePicker-input"
                          :auto-submit="true"
                          v-model="fromDateUnapproved"
                          :clearable="true"
                          :editable="true"
                      >
                        <div slot="label">
                          <span style="font-size: 9pt"> {{label.pages.fromDate}}</span>
                        </div>
                      </date-picker>
                    </b-col>
                    <b-col cols="5">
                      <date-picker
                          class="p-datePicker"
                          color="#3AAFA9"
                          input-class="p-datePicker-input"
                          :auto-submit="true"
                          v-model="toDateUnapproved"
                          :clearable="true"
                      >
                        <div slot="label">
                          <span style="font-size: 9pt"> {{label.pages.toDate}}</span>
                        </div>
                      </date-picker>
                    </b-col>
                    <b-col cols="2">
                      <b-button
                          variant="ps-success-second"
                          class="py-1 pb-2"
                          size="sm"
                          v-b-tooltip.hover
                          @click="searchByDateUnapproved"
                          :title="label.pages.search"
                      >
                        <b-icon icon="search" />
                      </b-button>
                    </b-col>
                  </b-row>
                </template>
                <template #radif="{data}">
                  <div>
                    {{ data.rowIndex + 1 }}
                  </div>
                </template>
                <template #actions="{data}">
                  <b-row class="justify-content-center">
                    <b-col cols="auto" class="px-0">
                      <button
                          @click="detailModalUnapproved(data)"
                          :id="'detailBtnTlp-' + data.data.id"
                      >
                        <b-icon icon="filter-square-fill" scale="1.1" variant="ps-tools-icon"></b-icon>
                      </button>
                      <b-tooltip
                        boundary="#app"
                        noninteractive
                        triggers="hover"
                        :target="'detailBtnTlp-' + data.data.id"
                      >
                        {{ label.buttons.ShowComment }}
                      </b-tooltip>
                    </b-col>
                    <b-col cols="auto" class="px-0">
                      <button
                          @click="delConfirm(data.data)"
                          :id="'deleteBtnTlp-' + data.data.id"
                      >
                        <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
                      </button>
                      <b-tooltip
                        boundary="#app"
                        noninteractive
                        triggers="hover"
                        :target="'deleteBtnTlp-' + data.data.id"
                      >
                        {{ label.buttons.delete }}
                      </b-tooltip>
                    </b-col>
                  </b-row>
                </template>
                <DxSorting mode="multiple"/>
                <DxLoadPanel :enabled="true"/>
                <DxScrolling mode="virtual"/>
              </DxDataGrid>
            </b-tab>

            <!-- Approved TAB -->
            <b-tab>
              <template #title>
                {{label.pages.confirm}}
              </template>
              <DxDataGrid
                  :show-row-lines="true"
                  :show-column-lines="true"
                  :show-borders="true"
                  :row-alternation-enabled="true"
                  :rtl-enabled="true"
                  :data-source="approvedComments"
                  :columns="aFields"
                  :remote-operations="true"
                  :column-auto-width="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  column-resizing-mode="widget"
                  :hover-state-enabled="true"
                  :noDataText="checkData"
                  @toolbar-preparing="onToolbarPreparing($event)"
                  key-expr="id"
                  class="ps_Table"
                  :height="dataGridHeight-50"
              >
                <DxSearchPanel
                    :visible="true"
                    :width="240"
                    :placeholder="label.pages.search"
                />
                <DxColumnChooser
                    :enabled="true"
                    mode="dragAndDrop"
                />
                <DxExport
                    :enabled="true"
                />
                <template #btnGroup>
                  <div>
                    <b-row class="ms-2">
                      <b-col cols="auto" class="px-0">
                        <b-button
                            variant="ps-secondary"
                            class="py-1 pb-2"
                            size="sm"
                            v-b-tooltip.hover
                            :title="label.buttons.reload"
                            @click="reloadDataApproved"
                        >
                          <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                </template>
                <template #btnRGroup>
                  <b-row>
                    <b-col cols="5">
                      <date-picker
                          class="p-datePicker"
                          color="#3AAFA9"
                          input-class="p-datePicker-input"
                          :auto-submit="true"
                          v-model="fromDateApproved"
                          :clearable="true"
                      >
                        <div slot="label">
                          <span style="font-size: 9pt"> {{label.pages.fromDate}}</span>
                        </div>
                      </date-picker>
                    </b-col>
                    <b-col cols="5">
                      <date-picker
                          class="p-datePicker"
                          color="#3AAFA9"
                          input-class="p-datePicker-input"
                          :auto-submit="true"
                          v-model="toDateApproved"
                          :clearable="true"
                      >
                        <div slot="label">
                          <span style="font-size: 9pt"> {{label.pages.toDate}}</span>
                        </div>
                      </date-picker>
                    </b-col>
                    <b-col cols="2">
                      <b-button
                          variant="ps-success-second"
                          class="py-1 pb-2"
                          size="sm"
                          v-b-tooltip.hover
                          @click="searchByDateApproved"
                          :title="label.pages.search"
                      >
                        <b-icon icon="search" />
                      </b-button>
                    </b-col>
                  </b-row>
                </template>
                <template #radif="{data}">
                  <div>
                    {{ data.rowIndex + 1 }}
                  </div>
                </template>
                <template #actions="{data}">
                  <b-row class="justify-content-center">
                    <b-col cols="auto" class="px-0">
                      <button
                          @click="detailModalApproved(data)"
                          :id="'detailBtnTlp-' + data.data.id"
                      >
                        <b-icon icon="filter-square-fill" scale="1.1" variant="ps-tools-icon"></b-icon>
                      </button>
                      <b-tooltip
                        boundary="#app"
                        noninteractive
                        triggers="hover"
                        :target="'detailBtnTlp-' + data.data.id"
                      >
                        {{ label.buttons.ShowComment }}
                      </b-tooltip>
                    </b-col>
                    <b-col cols="auto" class="px-0">
                      <button
                          @click="delConfirm(data.data)"
                          :id="'deleteBtnTlp-' + data.data.id"
                      >
                        <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
                      </button>
                      <b-tooltip
                        boundary="#app"
                        noninteractive
                        triggers="hover"
                        :target="'deleteBtnTlp-' + data.data.id"
                      >
                        {{ label.buttons.delete }}
                      </b-tooltip>
                    </b-col>
                  </b-row>
                </template>
                <DxSorting mode="multiple"/>
                <DxLoadPanel :enabled="true"/>
                <DxScrolling mode="virtual"/>
              </DxDataGrid>
            </b-tab>
          </b-tabs>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!-- Delete Confirm Modal -->
    <b-modal
        dir="rtl"
        v-model="delModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row>
          <p class="fs10 text-center lh1 mb-0">
            {{ label.captions.deleteCommentConfirm}}
            <br/>
            <strong>« {{ delTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="delModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1"
                @click="deleteComment"
            >
            {{label.buttons.deleteConfirm}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Detail Unapproved Modal -->
    <b-modal
        dir="rtl"
        v-model="unapprovedDetailModal"
        centered
        hide-footer
        hide-header
        size="md"
    >
      <b-container fluid>
        <b-row class="mt-2">
          <b-col cols="12" class="text-center mb-4">
            <img
                class="avatar-img"
                :src=comment.imageAddress
                alt="user avatar"
            />
          </b-col>
          <b-col cols="6">
            <p class="fs10 text-end">
              <small class="fs10">{{label.pages.firstName}}</small> : <strong>{{ comment.title }}</strong>
            </p>
          </b-col>
          <b-col cols="6">
            <p class="fs10 text-end">
              <small class="fs10">  {{label.pages.dateOfSave}}</small> : <strong>{{ comment.createdLocal }}</strong>
            </p>
          </b-col>
          <b-col cols="6">
            <p class="fs10 text-end">
              <small class="fs10">{{label.pages.email}}</small> : <strong>{{ comment.email }}</strong>
            </p>
          </b-col>
          <b-col cols="6">
            <p class="fs10 text-end">
              <small class="fs10"> {{label.pages.titleOfAlbum}}</small> : <strong>{{ comment.galleryTitle }}</strong>
            </p>
          </b-col>
          <b-col cols="12">
            <p class="fs10 text-end mb-1">
              {{label.form.commentText}}
              <b-icon icon="arrow90deg-down" scale="0.7" />
            </p>
            <p class="fs10 text-end bg-light p-2 lh1 rounded pre-wrap">
              <strong>{{ comment.body }}</strong>
            </p>
          </b-col>
          <b-col>
            <b-row class="justify-content-end">
              <b-col cols="auto" class="px-1">
                <b-button variant="ps-info" @click="seeComment(comment)"> {{label.pages.visitAlbum}}</b-button>
              </b-col>
              <b-col cols="auto" class="px-1">
                <b-button variant="ps-warning" @click="openReplayModal(comment)">  {{label.pages.reply}}</b-button>
              </b-col>
              <b-col></b-col>
              <b-col cols="auto" class="px-1">
                <b-button variant="ps-danger" v-if="!loadingBtn" @click="delConfirm(comment)"> {{label.pages.deleteComment}}</b-button>
              </b-col>
              <b-col cols="auto" class="px-1">
                <b-button variant="ps-success" v-if="!loadingBtn" @click="confirmComment(comment)"> {{label.pages.confirmComment}}</b-button>
                <b-button variant="ps-success" v-else disabled><b-spinner small></b-spinner></b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>

    <!-- Detail Approved Modal -->
    <b-modal
        dir="rtl"
        v-model="approvedDetailModal"
        centered
        hide-footer
        hide-header
        size="md"
    >
      <b-container fluid>
        <b-row class="mt-2">
          <b-col cols="12" class="text-center mb-4">
            <img
                class="avatar-img"
                :src=comment.imageAddress
                alt="user avatar"
            />
          </b-col>
          <b-col cols="6">
            <p class="fs10 text-end">
              <small class="fs10">{{label.pages.firstName}}</small> : <strong>{{ comment.title }}</strong>
            </p>
          </b-col>
          <b-col cols="6">
            <p class="fs10 text-end">
              <small class="fs10">  {{label.pages.dateOfSave}}</small> : <strong>{{ comment.createdLocal }}</strong>
            </p>
          </b-col>
          <b-col cols="6">
            <p class="fs10 text-end">
              <small class="fs10">{{label.pages.dateToConfirm}}</small> : <strong>{{ comment.actionDateLocal }}</strong>
            </p>
          </b-col>
          <b-col cols="6">
            <p class="fs10 text-end">
              <small class="fs10">{{label.pages.confirmOf}}</small> : <strong>{{ comment.actionUserName }}</strong>
            </p>
          </b-col>
          <b-col cols="6">
            <p class="fs10 text-end">
              <small class="fs10">{{label.pages.email}}</small> : <strong>{{ comment.email }}</strong>
            </p>
          </b-col>
          <b-col cols="6">
            <p class="fs10 text-end">
              <small class="fs10">{{label.pages.titleOfAlbum}}</small> : <strong>{{ comment.galleryTitle }}</strong>
            </p>
          </b-col>
          <b-col cols="12">
            <p class="fs10 text-end mb-1">
              {{label.form.commentText}}
              <b-icon icon="arrow90deg-down" scale="0.7" />
            </p>
            <p class="fs10 text-end bg-light p-2 lh1 rounded pre-wrap">
              <strong>{{ comment.body }}</strong>
            </p>
          </b-col>
          <b-col>
            <b-row class="justify-content-end">
              <b-col cols="auto" class="px-1">
                <b-button variant="ps-info" @click="seeComment(comment)">{{label.pages.visitAlbum}}</b-button>
              </b-col>
              <b-col cols="auto" class="px-1">
                <b-button variant="ps-warning" @click="openReplayModal(comment)">{{label.pages.reply}}</b-button>
              </b-col>
              <b-col></b-col>
              <b-col cols="auto" class="px-1">
                <b-button variant="ps-danger" @click="delConfirm(comment)">{{label.pages.delete}}</b-button>
              </b-col>
              <b-col cols="auto" class="px-1">
                <b-button variant="ps-success" v-if="!loadingBtn" @click="disproveComment(comment)">{{label.pages.returnToList}}</b-button>
                <b-button variant="ps-success" v-else disabled><b-spinner small></b-spinner>
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>

    <!--  Answer Comment Modal -->
    <b-modal
        dir="rtl"
        v-model="replayModal"
        header-bg-variant="ps-warning"
        centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{label.pages.replyToComment}} "{{ replayTitle }}"
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="replayModal=false"
            v-b-tooltip.hover
            :title="label.pages.closeTab"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
      </template>
      <b-container fluid>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="replayText" class="ps_label">{{label.pages.contentOfResponse}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-textarea rows="5" id="replayText" size="sm" v-model="replayText"/>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="replayModal=false"
            >
            {{label.pages.cansel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-success"
                size="sm"
                class="mx-1"
                @click="replayComment"
            >
            {{label.pages.record}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-success"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataGridMixin} from '@/components/dataGrid/dataGridMixin'
import label from "@/plugins/StaticLabels.js";

export default {
  name: 'GalleryComments',
  mixins: [dataGridMixin],
  data() {
    return {
      label,
      fromDateUnapproved: null,
      toDateUnapproved: null,
      fromDateApproved: null,
      toDateApproved: null,
      unFields: [
        {
          cellTemplate: 'radif',
          caption: 'ردیف',
          allowSorting: false,
          allowFiltering: false,
          width: '100',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'actions',
          caption: 'عملیات',
          allowSorting: false,
          allowFiltering: false,
          width: '110',
          alignment: 'center'
        },
        {
          dataField: 'title',
          caption: 'عنوان',
          dataType: 'string',
          width: '200',
          alignment: 'center'
        },
        {
          dataField: 'body',
          caption: 'محتوای نظر',
          allowSorting: false,
          allowFiltering: false,
          width: '300',
          alignment: 'center'
        },
        {
          dataField: 'galleryTitle',
          caption: 'عنوان آلبوم',
          dataType: 'string',
          alignment: 'center'
        },
        {
          dataField: 'createdLocal',
          caption: 'تاریخ ثبت',
          dataType: 'string',
          alignment: 'center'
        },
        {
          dataField: 'isAdminRead',
          caption: 'وضعیت (خوانده شده)',
          dataType: 'boolean',
          alignment: 'center'
        },
      ],
      aFields: [
        {
          cellTemplate: 'radif',
          caption: 'ردیف',
          allowSorting: false,
          allowFiltering: false,
          width: '100',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'actions',
          caption: 'عملیات',
          allowSorting: false,
          allowFiltering: false,
          width: '110',
          alignment: 'center'
        },
        {
          dataField: 'title',
          caption: 'عنوان',
          dataType: 'string',
          width: '200',
          alignment: 'center'
        },
        {
          dataField: 'body',
          caption: 'محتوای نظر',
          allowSorting: false,
          allowFiltering: false,
          width: '300',
          alignment: 'center'
        },
        {
          dataField: 'galleryTitle',
          caption: 'عنوان آلبوم',
          dataType: 'string',
          alignment: 'center'
        },
        {
          dataField: 'createdLocal',
          caption: 'تاریخ ثبت',
          dataType: 'string',
          alignment: 'center'
        },
        {
          dataField: 'actionDateLocal',
          caption: 'تاریخ تایید',
          dataType: 'string',
          alignment: 'center'
        },
      ],
      replayId: null,
      replayTitle: null,
      replayText: null,
      replayModal: false,
      delId: [],
      delModal: false,
      delTitle: null,
      approvedDetailModal: false,
      unapprovedDetailModal: false,
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      approvedComments: 'baseX/approvedComments',
      unapprovedComments: 'baseX/unapprovedComments',
      comment: 'baseX/comment',
      loadingBtn: 'loadingBtn',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.unapprovedDetailModal = false;
        this.approvedDetailModal = false;
        this.replayModal = false;
        this.delId = [];
        this.reloadDataApproved();
        this.reloadDataUnapproved();
      }
    },
  },
  methods: {
    seeComment(item) {
      const routeName = item.galleryTitle.split( " " ).join( "-" );
      if (item.galleryTypeId === 1) {
        window.open(process.env.VUE_APP_WEBSITE_URL + "imageGallery/" + item.galleryId + "/" + routeName, "_blank");
      } else if (item.galleryTypeId === 2) {
        window.open(process.env.VUE_APP_WEBSITE_URL + "videoGallery/" + item.galleryId + "/" + routeName, "_blank");
      } else {
        window.open(process.env.VUE_APP_WEBSITE_URL + "soundGallery/" + item.galleryId + "/" + routeName, "_blank");
      }
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: "before",
        template: "btnRGroup",
      });
      e.toolbarOptions.items.unshift({
        location: "after",
        template: "btnGroup",
      });
    },
    searchByDateUnapproved() {
      const payload = {
        pageSize: 1000000,
        pageNumber: 1,
        fromDate: this.fromDateUnapproved,
        toDate: this.toDateUnapproved,
        isApproved: false,
      }
      this.$store.dispatch('baseX/getGalleryUnapprovedComments', payload);
    },
    searchByDateApproved() {
      const payload = {
        pageSize: 1000000,
        pageNumber: 1,
        fromDate: this.fromDateApproved,
        toDate: this.toDateApproved,
        isApproved: true,
      }
      this.$store.dispatch('baseX/getGalleryApprovedComments', payload);
    },
    detailModalUnapproved(item) {
      const ids = [];
      ids.push(item.data.id);
      this.$store.dispatch('baseX/isAdminReadGalleryComment', ids);
      this.$store.dispatch('baseX/getGalleryCommentById', item.data.id);
      this.unapprovedDetailModal = true;
    },
    detailModalApproved(item) {
      const ids = [];
      ids.push(item.data.id);
      this.$store.dispatch('baseX/isAdminReadGalleryComment', ids);
      this.$store.dispatch('baseX/getGalleryCommentById', item.data.id);
      this.approvedDetailModal = true;
    },
    delConfirm(item) {
      this.delId.push(item.id);
      this.delTitle = item.title;
      this.delModal = true;
    },
    deleteComment() {
      this.$store.commit("setLoadingBtn", true);
      const payload = {
        pageId: 3,
        ids: this.delId
      }
      this.$store.dispatch('baseX/deleteComment', payload);
      this.delModal = false;
      this.delId = [];
    },
    confirmComment(item) {
      this.$store.commit("setLoadingBtn", true);
      const list = [];

      list.push(item.id);
      const payload = {
        pageId: 3,
        ids: list,
        isApprove: true,
      }
      this.$store.dispatch('baseX/editComment', payload);
    },
    disproveComment(item) {
      this.$store.commit("setLoadingBtn", true);
      const list = [];

      list.push(item.id);
      const payload = {
        pageId: 3,
        ids: list,
        isApprove: false,
      }
      this.$store.dispatch('baseX/editComment', payload);
    },
    openReplayModal(item) {
      this.replayId = item.id;
      this.replayTitle = item.title;
      this.replayModal = true;
    },
    replayComment() {
      this.$store.commit("setLoadingBtn", true);
      const payload = {
        id: this.replayId,
        replay: {
          answer: this.replayText
        },
      }
      this.$store.dispatch('baseX/answerGallery', payload);
    },
    reloadDataApproved() {
      this.replayId = null;
      this.replayTitle = null;
      this.replayText = null;
      this.fromDateApproved = null;
      this.toDateApproved = null;
      const payload = {
        pageSize: 1000000,
        pageNumber: 1,
        fromDate: null,
        toDate: null,
        isApproved: true,
      }
      this.$store.dispatch('baseX/getGalleryApprovedComments', payload);
    },
    reloadDataUnapproved() {
      this.replayId = null;
      this.replayTitle = null;
      this.replayText = null;
      this.fromDateUnapproved = null;
      this.toDateUnapproved = null;
      const payload = {
        pageSize: 1000000,
        pageNumber: 1,
        fromDate: null,
        toDate: null,
        isApproved: false,
      }
      this.$store.dispatch('baseX/getGalleryUnapprovedComments', payload);
    },
  },
  beforeCreate() {
    const payload1 = {
      pageSize: 1000000,
      pageNumber: 1,
      fromDate: null,
      toDate: null,
      isApproved: true,
    }
    this.$store.dispatch('baseX/getGalleryApprovedComments', payload1);
    const payload2 = {
      pageSize: 1000000,
      pageNumber: 1,
      fromDate: null,
      toDate: null,
      isApproved: false,
    }
    this.$store.dispatch('baseX/getGalleryUnapprovedComments', payload2);
  },
}
</script>
